import "rxjs/add/operator/toPromise";

import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import * as toastr from "toastr";

import { environment } from "../../environments/environment";
import { PrismDataSource } from "../models/prism-data-source.model";
import { UIError } from "../models/uiError.model";

@Injectable()
export class ReconApiService {
  constructor(private http: HttpClient) {}

  public async healthCheck(): Promise<boolean> {
    // console.log(`${environment.reconApiRoot.url}/SecureHealthCheck`);
    const response = await this.http
      .get(`${environment.reconApiRoot.url}/SecureHealthCheck`, {
        observe: "response",
      })
      .toPromise();
    return response.status === 200;
  }

  public async getPrismDataSources(): Promise<any> {
    // console.log(`${environment.reconApiRoot.url}/UserInfo/DataSources`);
    const response = await this.http
      .get<{ [client: string]: PrismDataSource[] }>(
        `${environment.reconApiRoot.url}/UserInfo/DataSources`
      )
      .toPromise()
      .catch((error) => {
        console.log(
          `Error occurred retrieving User Info DataSources at ${new Date()} status: ${error.status.toString()}`
        );
        this.logToElasticSearchFromUI(
          error,
          `${environment.reconApiRoot.url}/UserInfo/DataSources`
        );
      });
    return response;
  }

  public async getEnvironmentInformation(envId: string): Promise<boolean> {
    try {
      const response = await this.http
        .get(`${environment.reconApiRoot.url}/client/${envId}/test/`, {
          observe: "response",
        })
        .toPromise();
      return response.status === 200;
    } catch (ex) {
      console.log(ex);
    }
  }

  public async logToElasticSearchFromUI(
    errorObject,
    url: string
  ): Promise<boolean> {
    console.log(`${environment.reconApiRoot.url}/LogToElasticSearchFromUI`);
    let uiError = new UIError(errorObject, url);

    const response = await this.http
      .post(
        `${environment.reconApiRoot.url}/LogToElasticSearchFromUI/`,
        uiError
      )
      .toPromise();

    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/recon-api.service.ts